/*
 * @Author: Enzo
 * @Date: 2021-07-14 17:38:21
 * @LastEditTime: 2021-07-20 09:34:15
 * @LastEditors: Enzo
 * @Description:
 * @FilePath: /waimai_cd_fe_greentech_c/src/assets/apis/review.js
 * God is watching you
 */

import { get, post } from '../../utils/http';

// 查看被分配的项目接口
export const getAssignedProjects = (data) => get('/getAssignedProjects', data);

// 开启评审
export const beginJudge = (data) => post('/beginJudge', data);

// 保存评审结果
export const saveJudgeResult = (data) => post('/saveJudgeResult', data);

// 查看评审结果
export const queryJudgeResult = (data) => get('/queryJudgeResult', data);

export const queryVoteRecord = (data) => get('/judge/voteRecord', data);

export const submitVote = (data) => post('/judge/vote', data);

// 3 期接口
// 获取评审组别列表
export const getJudgeGroups = (data) => get('/judge/groups', data);

export const getJudgeProjects = (data) => get('/judge/project', data);

// 全部提交
export const batchSubmit = (data) => post('/batchSubmit', data, { dontPanic: true });

// 查询分组状态
export const queryGroupStatus = (groupId) => post('group/queryStatus', { groupId });
